import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/Layout.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/login", name: "Login", component: () => import("../views/Login.vue") },
  {
    path: "/",
    component: Layout,
    redirect: "/agents",
    children: [
      { path: "agents", name: "Agents", component: () => import("../views/agent/AgentList.vue"), meta: { title: "代理管理" } },
      { path: "commission-config", name: "CommissionConfig", component: () => import("../views/agent/CommissionConfig.vue"), meta: { title: "佣金比例配置" } },
      { path: "platform-config", name: "PlatformConfig", component: () => import("../views/platform/PlatformConfig.vue"), meta: { title: "平台抽成配置" } },
      { path: "wx-config", name: "WxConfig", component: () => import("../views/wxConfig/WxConfig.vue"), meta: { title: "微信登录/转账配置" } },
      { path: "ad-slots", name: "AdSlots", component: () => import("../views/adSlot/AdSlotList.vue"), meta: { title: "广告位管理" } },
      { path: "app-versions", name: "AppVersions", component: () => import("../views/version/VersionManage.vue"), meta: { title: "版本管理" } },
      { path: "users", name: "Users", component: () => import("../views/user/UserList.vue"), meta: { title: "用户管理" } },
      { path: "users/:id", name: "UserDetail", component: () => import("../views/user/UserDetail.vue"), meta: { title: "用户详情" } },
      { path: "questions", name: "Questions", component: () => import("../views/question/QuestionList.vue"), meta: { title: "题库管理" } },
      { path: "ad-view-records", name: "AdViewRecords", component: () => import("../views/adViewRecord/AdViewRecordList.vue"), meta: { title: "广告核销记录" } },
      { path: "withdraws", name: "Withdraws", component: () => import("../views/withdraw/WithdrawList.vue"), meta: { title: "提现管理" } },
      { path: "withdraw-rule", name: "WithdrawRule", component: () => import("../views/WithdrawRule/WithdrawRule.vue"), meta: { title: "提现规则配置" } },
    ],
  },
];

const router = new VueRouter({ mode: "history", routes });

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("admin_token");
  if (to.path === "/login") {
    next();
  } else if (!token) {
    next("/login");
  } else {
    next();
  }
});

export default router;